import React, { useEffect, useState } from "react"
import styles from "./metaIntegration.module.css"
import Button from './../../components/Form/Button'
import api from './../../services/api'
import { toast } from 'react-toastify'
import { BsMeta } from 'react-icons/bs'
import { MdAdsClick, MdCheckCircle, MdHistory, MdMoreVert, MdOpenInNew, MdOutlineCheck, MdPages, MdRefresh, MdSecurity, MdWarningAmber } from "react-icons/md"
import { AiOutlineDisconnect } from "react-icons/ai"
import FormGroup from './../../components/Form/FormGroup'
import ImageWithFallback from './../../components/ImageWithFallback'
import ModalConfirm from "../../components/Modal/ModalConfirm"
import ModalMetaPage from "../../components/Modal/ModalMetaPage"
import Loading from './../layouts/Loading'
import { useData } from "../../contexts/dataContext"
import { getStages } from "../../schemas/Stage"
import BackButton from "../../components/BackButton"
import { useParams } from "react-router-dom"
import Modal from "../../components/Modal"
import DatePicker from "../../components/Form/DatePicker"
import Select from "../../components/Form/Select"
import ModalMetaLeadgenSubmissions from "../../components/Modal/ModalMetaLeadgenSubmissions"
import ModalMetaAdAccountSelection from "./ModalMetaAdAccountSelection"
import ModalMetaPixelSelection from "./ModalMetaPixelSelection"
import ModalMetaPageSelection from "./ModalMetaPageSelection"

const formatDateTime = (date) => date ? new Date(date).toLocaleString("pt-BR") : "-"
const formatNumber = (value = 0) => Number(value || 0).toLocaleString("pt-BR")

const MetaIntegration = () => {
    const [linkedPages, setLinkedPages] = useState([])
    const [selectedPages, setSelectedPages] = useState([])
    const [reAuth, setReAuth] = useState(false)
    const [showModalDisconect, setShowModalDisconect] = useState(false)
    const [showModalConfirm, setShowModalConfirm] = useState(false)
    const [showModalPage, setShowModalPage] = useState(false)
    const [pageDisconect, setPageDisconect] = useState({})
    const [pageConect, setPageConect] = useState({})
    const [pageConfig, setPageConfig] = useState({})
    const [stages, setStages] = useState([])
    const [editablePageConfig, setEditablePageConfig] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showAssignmentHistoryModal, setShowAssignmentHistoryModal] = useState(false)
    const [assignmentHistoryPage, setAssignmentHistoryPage] = useState({})
    const [assignmentHistoryFilters, setAssignmentHistoryFilters] = useState({ dateStart: "", dateEnd: "", forms: [] })
    const [assignmentHistoryForms, setAssignmentHistoryForms] = useState([])
    const [isLoadingAssignmentHistoryForms, setIsLoadingAssignmentHistoryForms] = useState(false)
    const [assignmentHistory, setAssignmentHistory] = useState({ assignments: [], pagination: {} })
    const [isLoadingAssignmentHistory, setIsLoadingAssignmentHistory] = useState(false)
    const [openPageActions, setOpenPageActions] = useState("")
    const [submissionsPage, setSubmissionsPage] = useState(null)
    const [connections, setConnections] = useState([])
    const [adAccounts, setAdAccounts] = useState([])
    const [managingPixelsConnection, setManagingPixelsConnection] = useState(null)
    const [managingConnection, setManagingConnection] = useState(null)
    const [managingPagesConnection, setManagingPagesConnection] = useState(null)
    const [connectionToRemove, setConnectionToRemove] = useState(null)
    const [reconnectingConnection, setReconnectingConnection] = useState(null)

    const { funnels, teams, users, flagsByoptions, fields } = useData()
    const { account_id } = useParams()

    useEffect(() => {
        loadIntegration()
    }, [])

    const loadConnections = async () => {
        const response = await api.get("/integrations/meta/connections")
        setConnections(response?.data?.data || [])
        return response?.data?.data || []
    }

    const loadAdAccounts = async () => {
        const response = await api.get("/integrations/meta/adAccounts/authorized")
        setAdAccounts(response?.data?.data || [])
    }

    const loadSelectedPages = async () => {
        const response = await api.get("/integrations/meta/pages/selected")
        setSelectedPages(response?.data?.data || [])
        return response?.data?.data || []
    }

    const loadIntegration = () => {
        setIsLoading(true)
        Promise.all([loadConnections(), loadAdAccounts(), loadSelectedPages(), getAllLinkedPages(false)])
            .catch(err => toast.error(err?.response?.data?.message || "Não foi possível carregar a integração com a Meta."))
            .finally(() => setIsLoading(false))
    }

    const getAllLinkedPages = (withLoading = true) => {
        if (withLoading) setIsLoading(true)
        return api.get("/integrations/meta/accounts/linked").then(response => {
            const pages = response?.data?.data || []
            setLinkedPages(pages)
            if (withLoading) setIsLoading(false)
        }).catch(err => {
            if (withLoading) setIsLoading(false)
            toast.error(err?.response?.data?.message)
            throw err
        })
    }

    const handleSaveCode = async (code, connection = null) => {
        try {
            setIsLoading(true)
            const response = await api.patch("/integrations/meta/accessToken", { code, ...(connection?._id ? { reconnect_meta_user_account_id: connection._id } : {}) })
            setIsLoading(false)
            return response
        } catch (err) {
            setIsLoading(false)
            toast.error(err?.response?.data?.message)
            if (err?.response?.data?.action === "REAUTH") {
                setReAuth(true)
            }
            throw err
        }
    }

    const handleCloseModalConfirm = () => {
        setPageConect({})
        setShowModalConfirm(false)
    }

    const handleShowModalConfirm = (page) => {
        setPageConect(page)
        setShowModalConfirm(true)
    }

    const handleConectPage = (page) => {
        setIsLoading(true)
        api.post("/integrations/meta/connectPage", { pageId: page.id, pageName: page.name, pagePictureUrl: page.pictureUrl, meta_user_account_id: page.meta_user_account_id }).then(response => {
            const newPage = response?.data?.data
            if (newPage) {
                setLinkedPages(previousValue => {
                    return [...previousValue, newPage]
                })
                setSelectedPages(previousValue => previousValue.map(item => String(item.id) === String(newPage.page_id) ? { ...item, connected: true } : item))
                loadConnections().catch(() => {})
            }
            handleCloseModalConfirm()
            if (!newPage.configuration_restored) {
                handleShowModalPage(newPage._id)
                setEditablePageConfig(true)
            }
            setIsLoading(false)
            toast.success(response?.data?.message)
        }).catch(err => {
            setIsLoading(false)
            toast.error(err?.response?.data?.message)
        })
    }

    const handleCloseModalDisconect = () => {
        setPageDisconect({})
        setShowModalDisconect(false)
    }

    const handleShowModalDisconect = (page) => {
        setPageDisconect(page)
        setShowModalDisconect(true)
    }

    const handleDisconectPage = (page) => {
        setIsLoading(true)
        api.post("/integrations/meta/disconnectPage", { page_id: page._id }).then(response => {
            setLinkedPages(previousValue => previousValue?.filter(el => el._id !== page._id))
            handleCloseModalDisconect()
            setIsLoading(false)
            Promise.all([loadConnections(), loadSelectedPages()]).catch(() => {})
            toast.success(response?.data?.message)
        }).catch(err => {
            setIsLoading(false)
            toast.error(err?.response?.data?.message)
        })
    }

    const handleShowModalPage = (pageId) => {
        setIsLoading(true)
        api.get(`/integrations/meta/accounts/${pageId}`).then(response => {
            const page = response?.data?.data || {}
            setPageConfig(page)
            setShowModalPage(true)
            setIsLoading(false)
        }).catch(err => {
            setIsLoading(false)
            toast.error(err?.response?.data?.message)
        })
    }

    const handleCloseModalPage = () => {
        setPageConect({})
        setShowModalPage(false)
    }

    const handleChangePage = (pageId, data) => {
        setIsLoading(true)
        api.post(`/integrations/meta/accounts/${pageId}`, data).then(() => {
            setPageConfig(data)
            setEditablePageConfig(false)
            setIsLoading(false)
        }).catch(err => {
            setIsLoading(false)
            toast.error(err?.response?.data?.message)
        })
    }

    const handleLoginBM = (connection = null) => {
        if (!window.initializeFacebookSDK) {
            toast.error("Não foi possível iniciar o processo de conexão! Tente novamente em breve.")
            return
        }
        window.initializeFacebookSDK("348681404331700")
        const config_id = process.env.REACT_APP_META_LOGIN_CONFIG_ID || "1617923236528587"
        const configLogin = {
            config_id,
            response_type: 'code',
            override_default_response_type: true
        }
        if (reAuth || connection) {
            configLogin.auth_type = "rerequest"
        }
        setReconnectingConnection(connection)
        window.FB.login(function (response) {
            const newCode = response?.authResponse?.code
            if (!newCode) {
                setReconnectingConnection(null)
                if (response?.status && response.status !== "connected") toast.info("A autorização da Meta não foi concluída.")
                return
            }
            handleSaveCode(newCode, connection).then(async savedResponse => {
                const connectionId = savedResponse?.data?.data?.meta_user_account_id
                toast.success(savedResponse?.data?.message || "Conta Meta autorizada.")
                const [connectionsResult] = await Promise.allSettled([loadConnections(), loadAdAccounts(), loadSelectedPages(), getAllLinkedPages(false)])
                const items = connectionsResult.status === "fulfilled" ? connectionsResult.value : []
                const savedConnection = items.find(item => String(item._id) === String(connectionId))
                if (!connection && savedConnection) toast.info("Escolha separadamente as contas de anúncios, páginas e pixels nos botões desta conexão.")
            }).catch(() => {}).finally(() => setReconnectingConnection(null))
        }, configLogin)
    }

    const handleRemoveConnection = async connection => {
        setIsLoading(true)
        try {
            const response = await api.post("/integrations/meta/connections/disconnect", { meta_user_account_id: connection._id })
            setConnectionToRemove(null)
            await Promise.all([loadConnections(), loadAdAccounts(), loadSelectedPages()])
            toast.success(response?.data?.message || "Conta Meta removida.")
        } catch (err) {
            toast.error(err?.response?.data?.message || "Não foi possível remover a conta Meta.")
        } finally { setIsLoading(false) }
    }

    const connectionStatus = connection => {
        if (connection.connection_status === "RECONNECT_REQUIRED") return { label: "Reconexão necessária", detail: "O token expirou ou não está mais disponível.", warning: true }
        if (connection.connection_status === "PERMISSIONS_REQUIRED") return { label: "Permissões incompletas", detail: `Faltam ${connection.missing_permissions?.length || 0} permissão(ões).`, warning: true }
        if (connection.connection_status === "EXPIRING") return { label: "Acesso expirando", detail: connection.expires_at ? `Expira em ${new Date(connection.expires_at).toLocaleDateString("pt-BR")}.` : "Renove o acesso em breve.", warning: true }
        return { label: "Conectada", detail: connection.expires_at ? `Acesso válido até ${new Date(connection.expires_at).toLocaleDateString("pt-BR")}.` : "Permissões necessárias confirmadas.", warning: false }
    }

    const sortLinkedPages = (a, b) => {
        if (a.page_name > b.page_name) {
            return 1
        } else if (a.page_name < b.page_name) {
            return -1
        } else {
            return 0
        }
    }

    const sortAvailablePages = (a, b) => {
        if (a.name > b.name) {
            return 1
        } else if (a.name < b.name) {
            return -1
        } else {
            return 0
        }
    }

    const changeStages = async (funnel_id) => {
        getStages(funnel_id).then(stages => {
            setStages(stages?.map(stage => { return { id: stage._id, value: stage.name } }))
        }).catch(err => toast.error(err?.response?.data?.message))
    }

    const getFormsOptionsByPage = async (page) => {
        try {
            setIsLoadingAssignmentHistoryForms(true)
            const response = await api.get(`/integrations/meta/accounts/${page._id}/forms`)
            const forms = response?.data?.data?.data || []
            return forms.map(form => ({ id: form.id, value: form.name || form.id }))
        } catch (err) {
            toast.error(err?.response?.data?.message)
            return []
        } finally {
            setIsLoadingAssignmentHistoryForms(false)
        }
    }

    const getConnectionLabel = connectionId => {
        const connection = connections.find(item => String(item._id) === String(connectionId))
        if (!connection) return "credencial Meta removida"
        return connection.details_visible ? (connection.name || "credencial Meta") : (connection.connected_by?.name || "usuário removido")
    }

    const getAssignmentHistory = (page = assignmentHistoryPage, filters = assignmentHistoryFilters, pageNumber = 1) => {
        if (!page?.page_id) return

        setIsLoadingAssignmentHistory(true)
        api.get(`/integrations/meta/accounts/${page._id}/assignment-history`, {
            params: {
                source: "meta_leadgen",
                meta_page_id: page.page_id,
                ...(filters.forms?.length ? { forms: filters.forms.join(",") } : {}),
                ...(filters.dateStart ? { dateStart: filters.dateStart } : {}),
                ...(filters.dateEnd ? { dateEnd: filters.dateEnd } : {}),
                page: pageNumber,
                limit: 50,
            }
        }).then(response => {
            const data = response?.data?.data || { assignments: [], pagination: {} }
            setAssignmentHistory(previousValue => ({
                assignments: pageNumber > 1 ? [...(previousValue?.assignments || []), ...(data.assignments || [])] : data.assignments || [],
                pagination: data.pagination || {}
            }))
        }).catch(err => toast.error(err?.response?.data?.message))
            .finally(() => setIsLoadingAssignmentHistory(false))
    }

    const handleShowAssignmentHistory = async (page) => {
        const filters = { dateStart: "", dateEnd: "", forms: [] }
        setAssignmentHistoryPage(page)
        setAssignmentHistoryFilters(filters)
        setShowAssignmentHistoryModal(true)
        setAssignmentHistoryForms(await getFormsOptionsByPage(page))
        getAssignmentHistory(page, filters)
    }

    const handleCloseAssignmentHistory = () => {
        setShowAssignmentHistoryModal(false)
        setAssignmentHistoryPage({})
        setAssignmentHistoryForms([])
        setAssignmentHistory({ assignments: [], pagination: {} })
    }

    const handleAssignmentHistoryPeriodChange = (dateStart, dateEnd) => {
        setAssignmentHistoryFilters(previousValue => ({ ...previousValue, dateStart: dateStart || "", dateEnd: dateEnd || "" }))
    }

    const handleLoadMoreAssignmentHistory = () => {
        const nextPage = Number(assignmentHistory?.pagination?.page || 1) + 1
        getAssignmentHistory(assignmentHistoryPage, assignmentHistoryFilters, nextPage)
    }

    const getAssignmentRuleLabel = (assignment) => {
        const rule = assignment?.assignment_rule
        if (rule?.users?.includes("auto") && rule?.round_robin?.mode === "custom") return "Rodízio personalizado"
        if (rule?.users?.includes("auto")) return "Rodízio automático"
        if (rule?.users?.length) return "Usuário(s)"
        return "Regra não registrada"
    }

    const getUsersLabel = (items = []) => {
        const names = items.map(user => user.name).filter(Boolean)
        return names.length ? names.join(", ") : "-"
    }

    const handleTogglePageActions = (pageId) => {
        setOpenPageActions(previousValue => previousValue === pageId ? "" : pageId)
    }

    const handlePageAction = (action) => {
        setOpenPageActions("")
        action?.()
    }

    return (
        <div className={styles.container}>
            <div className="page-back-row">
                <BackButton fallback={`/${account_id}/integrations`} />
            </div>
            <section className={styles.hero}>
                <span className={styles.heroIcon}><BsMeta /></span>
                <div><small>Integração oficial</small><h1>Meta Ads</h1><p>Conecte uma conta empresarial e escolha explicitamente quais páginas, pixels e contas de anúncios esta organização poderá usar.</p><span className={styles.trust}><MdSecurity /> A Oktto não recebe nem armazena sua senha da Meta.</span></div>
                <Button fullWidth={false} onClick={() => handleLoginBM()}>{connections.length ? "Conectar outra conta" : "Conectar conta Meta"}</Button>
            </section>
            <section className={styles.statusGrid}>
                <div><MdCheckCircle /><strong>{connections.length}</strong><span>conexões Meta</span></div>
                <div><MdPages /><strong>{linkedPages.length}</strong><span>páginas conectadas</span></div>
                <div><MdAdsClick /><strong>{adAccounts.length}</strong><span>contas no Dashboard</span></div>
            </section>
            <section className={styles.cardWide}>
                <div className={styles.sectionHeading}><div><small>Credenciais e acesso</small><h2>Contas Meta conectadas</h2><p>Cada conexão enxerga apenas os ativos concedidos pela Meta. Um administrador ou quem realizou a conexão escolhe o que fica disponível nesta organização.</p></div></div>
                <div className={styles.connectionList}>
                    {connections.map(connection => {
                        const status = connectionStatus(connection)
                        return <article key={connection._id} className={`${styles.connectionCard} ${status.warning ? styles.connectionWarning : ""}`}>
                        <span className={styles.connectionIcon}><BsMeta /></span>
                        <div>
                            <strong>{connection.details_visible ? (connection.name || "Conta Meta") : "Credencial Meta"}</strong>
                            <span>{connection.details_visible ? `ID ${connection.meta_user_id || "não informado"}` : `Conectada por ${connection.connected_by?.name || "usuário removido"}`}</span>
                            <small className={status.warning ? styles.warningText : ""}>{status.warning ? <MdWarningAmber /> : <MdCheckCircle />}{connection.details_visible && `Conectada por ${connection.connected_by?.name || "usuário removido"} · `}{status.label} · {status.detail}</small>
                        </div>
                        <div className={styles.connectionCounts}><span>{connection.pages_count || 0} página(s)</span><span>{connection.dashboard_accounts_count || 0} Dashboard</span><span>{connection.pixels_count || 0} pixel(s)</span></div>
                        <div className={styles.connectionActions}>
                            {status.warning && connection.can_manage_assets && <Button fullWidth={false} disabled={reconnectingConnection?._id === connection._id} onClick={() => handleLoginBM(connection)}><MdRefresh /> {reconnectingConnection?._id === connection._id ? "Reconectando…" : "Reconectar"}</Button>}
                            {connection.can_manage_assets && <Button variant="secondary" fullWidth={false} onClick={() => setManagingConnection(connection)}>Gerenciar contas Ads</Button>}
                            {connection.can_manage_assets && <Button variant="neutral" fullWidth={false} onClick={() => setManagingPagesConnection(connection)}>Gerenciar páginas</Button>}
                            {connection.can_manage_assets && <Button variant="secondary" fullWidth={false} onClick={() => setManagingPixelsConnection(connection)}>Gerenciar pixels</Button>}
                            {connection.can_remove_connection && <Button variant="danger" fullWidth={false} onClick={() => setConnectionToRemove(connection)}><AiOutlineDisconnect /> Remover conta</Button>}
                        </div>
                    </article>})}
                    {!connections.length && <div className={styles.emptyState}><BsMeta /><div><strong>Nenhuma conta conectada</strong><p>Conecte uma conta empresarial para descobrir páginas e contas Meta Ads.</p></div></div>}
                </div>
            </section>
            <section className={styles.cardWide}>
                <div className={styles.sectionHeading}><div><small>Contas autorizadas</small><h2>Contas de anúncios</h2><p>Contas autorizadas para consultar métricas no Dashboard. Os pixels para conversões são selecionados separadamente.</p></div></div>
                <div className={styles.adAccountGrid}>
                    {adAccounts.map(account => <article key={account._id}><MdAdsClick /><div><strong>{account.ad_account_name || "Conta Meta Ads"}</strong><span>{account.ad_account_id}{account.currency ? ` · ${account.currency}` : ""}</span><small>{account.business_name || "Acesso direto"}</small></div></article>)}
                    {!adAccounts.length && <div className={styles.emptyState}><MdAdsClick /><div><strong>Nenhuma conta autorizada</strong><p>Use “Gerenciar contas Ads” em uma conexão para liberar contas ao Dashboard.</p></div></div>}
                </div>
            </section>
            <section className={styles.cardWide}>
                <div className={styles.sectionHeading}><div><small>Pixels autorizados</small><h2>Pixels e conversões</h2><p>Use “Gerenciar pixels” para escolher quais pixels poderão receber conversões offline.</p></div></div>
                <div className={styles.adAccountGrid}>
                    {connections.flatMap(connection => (connection.selected_pixels || []).map(pixel => <article key={`${connection._id}-${pixel.id}`}><MdAdsClick /><div><strong>{pixel.name}</strong><span>{pixel.id}</span><small>{pixel.business_name}</small></div></article>))}
                    {!connections.some(connection => connection.pixels_count) && <p>Nenhum pixel autorizado.</p>}
                </div>
            </section>
            <div className={styles.content}>
                <div className={styles.card}>
                    <div className={styles.header}>
                        <MdPages />
                        <span>Páginas e Lead Ads</span>
                    </div>
                    <div className={styles.body}>
                        <FormGroup labelText="Páginas Conectadas">
                            {linkedPages.length > 0 && linkedPages.sort(sortLinkedPages).map((page, index) => (
                                <div className={`${styles.groupPage} ${openPageActions === page._id ? styles.menuOpen : ""}`} key={index}>
                                    <div className={styles.left}>
                                        {page?.page_picture_url &&
                                            <ImageWithFallback
                                                src={page?.page_picture_url}
                                                alt="Imagem de Perfil da Página"
                                                functionError={() => <BsMeta style={{ width: "100%", height: "100%", padding: "1em" }} />}
                                            />
                                        }
                                    </div>
                                    <div className={styles.center}>
                                        <span>{page.page_name || "-"}</span>
                                        <small>
                                            {formatNumber(page.submissions_count)} cadastros
                                            {Number(page.pending_count || 0) > 0 && <> • <strong>{formatNumber(page.pending_count)} pendentes</strong></>}
                                            {Number(page.duplicate_blocked_count || 0) > 0 && <> • <strong>{formatNumber(page.duplicate_blocked_count)} duplicados</strong></>}
                                            {Number(page.failed_count || 0) > 0 && <> • <strong className={styles.failedCount}>{formatNumber(page.failed_count)} com falha</strong></>}
                                        </small>
                                        {page.last_received_at && <small>Último recebido: {formatDateTime(page.last_received_at)}</small>}
                                    </div>
                                    <div className={styles.actionsMenu}>
                                        {openPageActions === page._id &&
                                            <button type="button" className={styles.menuBackdrop} onClick={() => setOpenPageActions("")} aria-label="Fechar menu de ações" />
                                        }
                                        <button type="button" className={styles.menuButton} onClick={() => handleTogglePageActions(page._id)} aria-label="Ações da página">
                                            <MdMoreVert />
                                        </button>
                                        {openPageActions === page._id &&
                                            <div className={styles.menuList}>
                                                <button type="button" onClick={() => handlePageAction(() => handleShowModalPage(page._id))}>Configurar</button>
                                                <button type="button" onClick={() => handlePageAction(() => setSubmissionsPage(page))}>Cadastros recebidos</button>
                                                <button type="button" onClick={() => handlePageAction(() => handleShowAssignmentHistory(page))}>Histórico de atribuição</button>
                                                <button type="button" className={styles.dangerAction} onClick={() => handlePageAction(() => handleShowModalDisconect(page))}>Desconectar página</button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            ))}
                            {linkedPages.length === 0 && <span>Nenhuma página conectada até o momento!</span>}
                        </FormGroup>
                        <FormGroup labelText="Páginas selecionadas e prontas para conexão">
                            {selectedPages.filter(page => !page.connected).length > 0 && selectedPages.filter(page => !page.connected).sort(sortAvailablePages).map((page, index) => (
                                <div className={styles.groupPage} key={index}>
                                    <div className={styles.left}>
                                        {page?.pictureUrl &&
                                            <ImageWithFallback
                                                src={page?.pictureUrl}
                                                alt="Imagem de Perfil da Página"
                                                functionError={() => <BsMeta style={{ width: "100%", height: "100%", padding: "1em" }} />}
                                            />
                                        }
                                    </div>
                                    <div className={styles.center}>
                                        <span>{page.name || "-"}</span>
                                        <small className={styles.readyBadge}>Pronta para conexão</small>
                                        <small>Via {getConnectionLabel(page.meta_user_account_id)}</small>
                                    </div>
                                    <Button variant="primary" onClick={() => handleShowModalConfirm(page)}>
                                        Conectar
                                    </Button>
                                </div>
                            ))}
                            {connections.length > 0 && selectedPages.filter(page => !page.connected).length === 0 && <span>Nenhuma página aguardando conexão. Use “Gerenciar páginas” para selecionar.</span>}
                            {!connections.length && <span>Conecte uma conta Meta para listar páginas disponíveis.</span>}
                        </FormGroup>
                    </div>
                </div>
            </div>
            {showModalConfirm &&
                <ModalConfirm
                    closeModal={handleCloseModalConfirm}
                    icon={<MdOutlineCheck />}
                    title="Deseja realmente conectar a página?"
                    description={`Ao conectar a página ${pageConect.name} você concorda com os detalhes abaixo`}
                    text="Após a conexão, os leads gerados em suas campanhas de cadastro vinculados a essa página serão importados automáticamente para nossa plataforma. Na próxima tela será possível definir algumas configurações adicionais!"
                    onSubmit={() => handleConectPage(pageConect)}
                />
            }
            {showModalDisconect &&
                <ModalConfirm
                    closeModal={handleCloseModalDisconect}
                    icon={<AiOutlineDisconnect />}
                    title="Deseja realmente desconectar a página?"
                    description={`Ao desconectar a página ${pageDisconect.page_name} você concorda com os detalhes abaixo`}
                    text="Após a desconexão, os leads gerados em suas campanhas de cadastro vinculados a essa página deixarão de ser importados automáticamente para nossa plataforma."
                    onSubmit={() => handleDisconectPage(pageDisconect)}
                />
            }
            {showModalPage &&
                <ModalMetaPage
                    closeModal={handleCloseModalPage}
                    icon={<ImageWithFallback
                        src={pageConfig?.page_picture_url}
                        alt="Imagem de Perfil da Página"
                        functionError={() => <BsMeta style={{ width: "32px", height: "32px" }} />}
                    />}
                    title={pageConfig?.page_name}
                    description="Conectada via Meta"
                    data={pageConfig}
                    editable={editablePageConfig}
                    funnels={funnels}
                    stages={stages}
                    teams={teams}
                    users={users}
                    flags={flagsByoptions}
                    allFields={fields}
                    getStages={changeStages}
                    setEditable={setEditablePageConfig}
                    onSubmit={handleChangePage}
                />
            }
            {showAssignmentHistoryModal &&
                <Modal
                    icon={<MdHistory />}
                    title="Histórico de atribuição"
                    description={`Página ${assignmentHistoryPage?.page_name || ""}`}
                    closeModal={handleCloseAssignmentHistory}
                    fullWidith={true}
                    heightFitContent={true}
                >
                    <div className={styles.assignmentHistoryModal}>
                        <div className={styles.assignmentHistoryFilters}>
                            <DatePicker multiple={true} name="Período" dateStart={assignmentHistoryFilters.dateStart || ""} dateEnd={assignmentHistoryFilters.dateEnd || ""} onChange={handleAssignmentHistoryPeriodChange} />
                            <Select name="Formulários" placeholder="Todos os formulários" options={assignmentHistoryForms} selected={assignmentHistoryFilters.forms || []} multiple={true} loading={isLoadingAssignmentHistoryForms} loadingText="Buscando formulários..." emptyOptionsText="Nenhum formulário encontrado" onChange={(forms) => setAssignmentHistoryFilters(previousValue => ({ ...previousValue, forms }))} />
                            <Button variant="secondary" onClick={() => getAssignmentHistory()}>Filtrar</Button>
                        </div>
                        <div className={styles.assignmentHistorySummary}>
                            <strong>{formatNumber(assignmentHistory?.pagination?.total || assignmentHistory?.assignments?.length || 0)}</strong>
                            <span>atribuições encontradas</span>
                        </div>
                        <div className={styles.assignmentHistoryTable}>
                            <div className={styles.assignmentHistoryHeader}>
                                <span>Data</span>
                                <span>Formulário</span>
                                <span>Lead</span>
                                <span>Atribuído para</span>
                                <span>Regra</span>
                                <span>Elegíveis</span>
                            </div>
                            {assignmentHistory?.assignments?.map(assignment => (
                                <div key={assignment._id} className={styles.assignmentHistoryRow}>
                                    <span>{formatDateTime(assignment.created_at)}</span>
                                    <span>{assignment.meta_form_name || assignment.meta_form_id || "-"}</span>
                                    <span>
                                        {assignment?.lead?.url ?
                                            <a href={assignment.lead.url} target="_blank" rel="noreferrer">{assignment.lead.name} <MdOpenInNew /></a>
                                            : assignment?.lead?.name || "-"
                                        }
                                    </span>
                                    <strong>{getUsersLabel(assignment.assigned_users)}</strong>
                                    <span>{getAssignmentRuleLabel(assignment)}</span>
                                    <span>{getUsersLabel(assignment.eligible_users)}</span>
                                </div>
                            ))}
                            {!assignmentHistory?.assignments?.length && !isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>Nenhuma atribuição registrada nesse período.</div>
                            }
                            {isLoadingAssignmentHistory &&
                                <div className={styles.assignmentHistoryEmpty}>Carregando histórico...</div>
                            }
                        </div>
                        {assignmentHistory?.pagination?.has_more &&
                            <div className={styles.assignmentHistoryLoadMore}>
                                <Button variant="secondary" onClick={handleLoadMoreAssignmentHistory} disabled={isLoadingAssignmentHistory}>
                                    {isLoadingAssignmentHistory ? "Carregando..." : "Carregar mais"}
                                </Button>
                            </div>
                        }
                    </div>
                </Modal>
            }
            {submissionsPage &&
                <ModalMetaLeadgenSubmissions
                    page={submissionsPage}
                    closeModal={() => setSubmissionsPage(null)}
                    onChanged={getAllLinkedPages}
                />
            }
            {managingPixelsConnection && <ModalMetaPixelSelection connection={managingPixelsConnection} closeModal={() => setManagingPixelsConnection(null)} onSaved={loadConnections} />}
            {managingConnection && <ModalMetaAdAccountSelection connection={managingConnection} closeModal={() => setManagingConnection(null)} onSaved={async () => { await Promise.all([loadConnections(), loadAdAccounts()]); toast.success("Autorizações das contas Meta atualizadas.") }} />}
            {managingPagesConnection && <ModalMetaPageSelection connection={managingPagesConnection} closeModal={() => setManagingPagesConnection(null)} onSaved={async () => { await Promise.all([loadConnections(), loadSelectedPages(), getAllLinkedPages(false)]); toast.success("Seleção de páginas Meta atualizada.") }} />}
            {connectionToRemove && <ModalConfirm closeModal={() => setConnectionToRemove(null)} icon={<AiOutlineDisconnect />} title="Remover conta Meta?" description={`${connectionToRemove.name || "Esta credencial"} será removida desta organização.`} text="As autorizações de contas de anúncios e as páginas ainda não conectadas deixarão de ficar disponíveis. Esta ação só é permitida quando não existem páginas conectadas por essa conta." onSubmit={() => handleRemoveConnection(connectionToRemove)} />}
            {isLoading && <Loading fullPage={true} />}
        </div>
    )
}

export default MetaIntegration
